{
	"submitTitle": "Material auswählen",
	"summary": {
		"title": "Zusammenfassung",
		"declarationTypeTitle": "Erklärungstyp",
		"projectReferenceTitle": "Projektreferenz"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Erklärungstyp auswählen",
			"customerProject": {
				"title": "Kundenprojekt",
				"description": "Das Material wurde für ein externes Projekt verwendet. Nun muss ich eine Erklärung bereitstellen, die die CO₂ eq. Reduktionen für meinen Kunden darlegt."
			},
			"internalProjectOrProduct": {
				"title": "Internes Projekt / Produkt",
				"description": "Das Material wurde für ein internes Projekt oder Produkt verwendet. Ich muss eine Erklärung erstellen, um die CO₂ eq. Reduktionen für unseren eigenen Betrieb geltend zu machen."
			}
		},
		"addProjectReferenceSection": {
			"title": "Projektreferenz hinzufügen",
			"subTitle": "Sie müssen die CO₂ eq. Reduktionen einer Projektreferenz zuordnen, für die Sie die Erklärung erstellen möchten.",
			"projectReferencePlaceholder": "Projektreferenz"
		},
		"selectProjectSection": {
			"title": "Projekt auswählen",
			"createNewProjectPlaceholder": "Neues Projekt erstellen"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Erklärungstyp ist erforderlich",
		"projectReferenceRequired": "Projektreferenz ist erforderlich",
		"fetchProjectsError": "Frühere Projekte konnten nicht abgerufen werden"
	}
}
